<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-readonly-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" >
       <template slot="state">
          <span class="custom-input">{{detailFormData.state !== 1 ? '已处理' : '未处理'}}</span>
        </template>
        <template slot="result">
          <span class="custom-input">{{detailFormData.state | FILTER_Warning_State}}</span>
        </template>
        <template slot="countCurrent">
          <span class="custom-input">{{$wtUtil.transWeight(detailFormData.countCurrent)}}kg</span>
        </template>
        <template slot="countReal">
          <span class="custom-input">{{$wtUtil.transWeight(detailFormData.countReal)}}kg</span>
        </template>
      </wt-readonly-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WarningRecordViewPage',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      detailForm: {
        title: '预警详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '预警编号', key: 'id', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '社区名称', key: 'communityName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '站点', key: 'siteName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '站点地址', key: 'siteAddress', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '站长姓名', key: 'employeesName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '站长手机号', key: 'employeesPhone', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '垃圾类型', key: 'garbageName', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '出库时间', key: 'updateTime', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '出库当日（重量）', key: 'countCurrent', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '实际出库（重量）', key: 'countReal', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '预警值', key: 'warnCount', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '状态', key: 'state', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '处理结果', key: 'result', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '原因', key: 'remark', type: 'text', className: 'wt-col-12', disabled: true }]
      },
      detailFormButtons: {
        title: '预警详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '预警详情' }})
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'close')
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.warning.warningRecordDetailData
    })
  }
}
</script>
